import { Usuario } from '../models/usuario.model';
export const globalUser: Usuario = {
};

export default globalUser;
